export const AGREEMENTS = {
  REGULATIONS: 'REGULATIONS',
  DATA_PROCESSING: 'DATA_PROCESSING',
  INTEGRATOR_PROCESSING: 'INTEGRATOR_PROCESSING',
  MARKETING: 'MARKETING',
  SECURITY_DATA: 'SECURITY_DATA',
  PERSONAL_DATA: 'PERSONAL_DATA',
  ADMIN_INFO: 'ADMIN_INFO'
}
